// import React from "react";
// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const user = sessionStorage.getItem("chaafo_user");

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }


import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { GlobalContext } from "../Context/GlobalContext";

const LOGIN_ROUTE = "/login";

export default function ProtectedRoute() {
  const location = useLocation();

  const { user, authLoading } = useContext(GlobalContext);

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-blue-50">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-200 border-t-blue-700" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={LOGIN_ROUTE}
        replace
        state={{
          from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          },
        }}
      />
    );
  }

  return <Outlet />;
}
